import { render, staticRenderFns } from "./nitrTask.vue?vue&type=template&id=573ab5d0&scoped=true&"
import script from "./nitrTask.vue?vue&type=script&lang=js&"
export * from "./nitrTask.vue?vue&type=script&lang=js&"
import style0 from "./nitrTask.vue?vue&type=style&index=0&id=573ab5d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573ab5d0",
  null
  
)

export default component.exports